import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter, HostListener } from '@angular/core';
import { SingleOrDoubleClick } from '../image-modal.component';

@Component({
  selector: 'app-image-branch',
  templateUrl: './image-branch.component.html',
  styleUrls: ['./image-branch.component.css']
})
export class ImageBranchComponent implements OnInit, OnChanges {

  @Input() data: Array<any>;
  @Input() options;
  @Input() selectedFolder: string;
  @Input() rightClick: boolean = false;
  @Input() fileCount;
  @Output() bubble = new EventEmitter();
  @HostListener('document:click') documentClick() { this.showContext = false; }
  click;
  timer;
  renaming = false;
  preventFalseNullEvent = false;
  showContext = false;
  context = {
    top:'100px',
    left:'200px',
    item:null
  }
  hovId;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(c: SimpleChanges) {
    if (!!c.data && !!c.data.currentValue && this.selectedFolder != null && c.data.currentValue.find(x => x.id == this.selectedFolder)) {
      this.showChildren(null, this.data.find(x => x.id == this.selectedFolder));
    }
    if (!!c.selectedFolder && !!c.selectedFolder.currentValue) {

    }
  }

  folderClick(id) {
    if (!this.click) {
      this.click = id;
      this.timer = setTimeout(() => {
        let f = this.data.find(x => x.id == this.click);
        if (!!f) { this.showChildren(null, f) };
        this.click = null;
      }, 200)
    }
    else {
      clearTimeout(this.timer);
      let f = this.data.find(x => x.id == this.click);
      if (!!f && !['Ordrestyring', 'root'].includes(f.name) && !['folder.customer','folder.technician', 'folder.admin'].includes(f.name) ) { f.editing = true }
      this.click = null;
    }
  }

  contextMenu(event, item){
    event.preventDefault();
    this.showChildren(null, item);
    if(this.rightClick && !['folder.customer','folder.technician', 'folder.admin'].includes(item.name)){
      this.showContext = true;
      this.context.top = (event.clientY - 20).toString() + 'px';
      this.context.left = (event.clientX + 10).toString() + 'px';
      this.context.item = item;
    }
    // document.addEventListener('click', (e)=>{    })
  }

  showChildren(event, x) {
    x.showChildren = true;
    this.bubble.emit(
      {
        type: 'selectFolder',
        folder: x
      }
    )
  }

  itemHover(event,id){
    event ? this.hovId = id : this.hovId = null;
  }

  itemDrop(event, toId, x) {
    this.hovId = null;
    this.bubble.emit(
      {
        type: 'dropped',
        id: toId,
        object: x
      }
    )
  }

  dragStart(event, id, x) {
    this.bubble.emit(
      {
        type: 'draggingFolder',
        id: id,
        object : x
      }
    )
  }

  dragEnd(event, id) {
    setTimeout(() => {
      this.bubble.emit({ type: 'dragStop', id: null })
    }, 50)
  }

  addFolder(){
    this.bubble.emit({ type:'addNewSubFolder', id: this.context.item.id })
  }

  renameFolder(x, event) {
    // check and see that no other folder is named the same..
    if (this.data.find(x => x.name == event.target.value) != null) {
      x.editing = false;
    }
    else {
      // folder has an original name so it can be transmitted to parent
      console.log(event, x)
      let id = typeof(event.target.value) == 'string' ?  event.target.value : event.target.value.success;
      this.bubble.emit({ type: 'folderRename', id: x.id, oldName: x.name, newName: event.target.value });
      x.name = event.target.value;
      x.editing = false;
    }
  }

  deleteFolder(){
    this.bubble.emit({ type:'deleteFolder', id:this.context.item.id, item:this.context.item })
  }

  rebubble(event) {
    this.bubble.emit(event)
  }
}
